import { v4 as uuidv4 } from 'uuid';
import { selecetedShopIdActionTypes } from './selected-shop-id-reducer';

export enum paymentReducerActionTypes {
  UPDATE_PAYMENTS = 'PAYMENT_UPDATE_PAYMENTS',
  UPDATE_UUID = 'PAYMENT_UPDATE_UUID',
  UPDATE_SHOW_PAYMENT_MODAL = 'PAYMENT_UPDATE_SHOW_PAYMENT_MODAL',
  UPDATE_IS_LOADING = 'PAYMENT_UPDATE_IS_LOADING',
  UPDATE_IS_PAID = 'PAYMENT_UPDATE_IS_PAID',
  UPDATE_CLIENT_SECRET = 'PAYMENT_UPDATE_CLIENT_SECRET',
  UPDATE_PAYMENT_INTENT_ERROR = 'PAYMENT_UPDATE_INTENT_ERROR',
}

interface PaymentUpdatePaymentsAction {
  type: paymentReducerActionTypes.UPDATE_PAYMENTS;
  payload: any[];
}

interface PaymentUpdateUuidAction {
  type: paymentReducerActionTypes.UPDATE_UUID;
}

interface PaymentUpdateShowPaymentModalAction {
  type: paymentReducerActionTypes.UPDATE_SHOW_PAYMENT_MODAL;
  payload: boolean;
}

interface PaymentUpdateIsLoadingAction {
  type: paymentReducerActionTypes.UPDATE_IS_LOADING;
  payload: boolean;
}

interface PaymentUpdateIsPaidAction {
  type: paymentReducerActionTypes.UPDATE_IS_PAID;
  payload: boolean;
}

interface PaymentUpdateClientSecretAction {
  type: paymentReducerActionTypes.UPDATE_CLIENT_SECRET;
  payload: string;
}

interface ErrorUpdatePaymentIntentErrorAction {
  type: 'ERROR_PAYMENT_INTENT';
  payload: string;
}

interface SelecetedShopIdAction {
  type: selecetedShopIdActionTypes.SELECTED_SHOP_ID_UPDATE;
  payload: string;
}

export type PaymentReducerAction =
  | PaymentUpdatePaymentsAction
  | PaymentUpdateUuidAction
  | PaymentUpdateShowPaymentModalAction
  | PaymentUpdateIsLoadingAction
  | PaymentUpdateIsPaidAction
  | PaymentUpdateClientSecretAction
  | ErrorUpdatePaymentIntentErrorAction
  | SelecetedShopIdAction;

export interface PaymentReducerState {
  payments: any[];
  uuid: string;
  isLoading: boolean;
  isPaid: boolean;
  showPaymentModal: boolean;
  paymentIntentClientSecret: string | null;
}

export const paymentReducerinitialState: PaymentReducerState = {
  payments: [],
  uuid: uuidv4(),
  isLoading: false,
  isPaid: false,
  showPaymentModal: false,
  paymentIntentClientSecret: null,
};

const paymentReducer = (
  state: PaymentReducerState,
  action: PaymentReducerAction
): PaymentReducerState => {
  switch (action.type) {
    case paymentReducerActionTypes.UPDATE_PAYMENTS: {
      return {
        ...state,
        payments: action.payload,
      };
    }
    case paymentReducerActionTypes.UPDATE_UUID: {
      return {
        ...state,
        uuid: uuidv4(),
      };
    }
    case paymentReducerActionTypes.UPDATE_SHOW_PAYMENT_MODAL: {
      if (!state.isPaid) {
        return {
          ...state,
          showPaymentModal: action.payload,
        };
      }

      return state;
    }
    case paymentReducerActionTypes.UPDATE_IS_LOADING: {
      return {
        ...state,
        isLoading: action.payload,
      };
    }
    case paymentReducerActionTypes.UPDATE_IS_PAID: {
      return {
        ...state,
        isPaid: action.payload,
      };
    }
    case paymentReducerActionTypes.UPDATE_CLIENT_SECRET: {
      return {
        ...state,
        paymentIntentClientSecret: action.payload,
      };
    }
    case 'ERROR_PAYMENT_INTENT': {
      return {
        ...state,
        paymentIntentClientSecret: null,
      };
    }
    case selecetedShopIdActionTypes.SELECTED_SHOP_ID_UPDATE: {
      return {
        ...state,
        isPaid: false,
        showPaymentModal: false,
        paymentIntentClientSecret: null,
      };
    }
    default:
      return state;
  }
};

export default paymentReducer;
